import { createSigninOnReturnHandler } from "@react/foundation/auth";

import { isUserToken } from "@platform/core";

import { API } from "../../../bootstrap/api.ts";
import { logger } from "../../../bootstrap/logger.ts";
import { router } from "../../../bootstrap/router.ts";
import { AUTH_CALLBACK_URL } from "../lib/auth-callback-url.ts";
import { authStore } from "../state/auth.ts";
import { authSessionStore } from "../state/auth-session.ts";
import { signinOnReturnStore } from "../state/signin-on-return.ts";

import { initConfig } from "./init-config.ts";

export const signinOnReturn = createSigninOnReturnHandler({
  appCallbackUrl: AUTH_CALLBACK_URL.mobile,
  authSessionStore,
  authStore,
  getAuthToken: API.auth.getAuthToken,
  homeUrl: router.getUrl("Home"),
  isValidToken: isUserToken,
  logger,
  onSignin: initConfig,
  signinOnReturnStore,
  webCallbackUrl: AUTH_CALLBACK_URL.web,
});
